import { useSessionStorage } from '@vueuse/core'
import { useSetStorageSerializer } from './useSetStorageSerializer'

export function useVisitedItems<T extends string>() {
  const sessionStorage = useSessionStorage<Set<T> | null>(
    'visitedItems',
    null,
    {
      serializer: useSetStorageSerializer<T>(),
    },
  )

  function has(item: T): boolean {
    return sessionStorage.value?.has(item) ?? false
  }

  function add(item: T) {
    if (!sessionStorage.value) {
      sessionStorage.value = new Set<T>()
    }
    sessionStorage.value.add(item)
  }

  return { add, has }
}
